'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import Modal from 'react-modal';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import newsletterPromotionSignupAction from '@/app/_lib/actions/NewsletterPromotionSignupAction';
import RecaptchaDisclaimer from '@/app/_components/RecaptchaDisclaimer';
import SubmitWithPendingButton from '@/app/_components/SubmitWithPendingButton';
import { useGlobalMessage } from '@/app/_lib/hooks';
import { useReCaptcha } from 'next-recaptcha-v3';
import { trackNewsletterSignup } from '@/app/_lib/analytics/ga4';
const modalImages = [{
  desktop: '/images/modal-images/hive-popup-diptych-general-finn-juhl-chieftain.jpg',
  mobile: '/images/modal-images/mobile/hive-popup-diptych-mobile-general-finn-juhl-chieftain.jpg'
}, {
  desktop: '/images/modal-images/hive-popup-diptych-general-flos-luminator.jpg',
  mobile: '/images/modal-images/mobile/hive-popup-diptych-mobile-general-flos-luminator.jpg'
}, {
  desktop: '/images/modal-images/hive-popup-diptych-general-kartell-pilastro.jpg',
  mobile: '/images/modal-images/mobile/hive-popup-diptych-mobile-general-kartell-pilastro.jpg'
}, {
  desktop: '/images/modal-images/hive-popup-diptych-general-knoll-platner.jpg',
  mobile: '/images/modal-images/mobile/hive-popup-diptych-mobile-general-knoll-platner.jpg'
}];
const NewsletterSignupModal = t0 => {
  const $ = _c(50);
  const {
    isOpen,
    onBackgroundClick,
    onRefuse,
    onSignupComplete,
    contentLabel
  } = t0;
  const [modalImage, setModalImage] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const addGlobalMessage = useGlobalMessage();
  const {
    executeRecaptcha
  } = useReCaptcha();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function afterOpenModal() {
      setEmail("");
      setErrorMessage("");
      setModalImage(modalImages[Math.floor(Math.random() * modalImages.length)]);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const afterOpenModal = t2;
  let t3;
  if ($[2] !== addGlobalMessage || $[3] !== email || $[4] !== executeRecaptcha || $[5] !== onSignupComplete) {
    t3 = async e => {
      e.preventDefault();
      setLoading(true);
      setErrorMessage("");
      const recaptchaToken = await executeRecaptcha("newsletter_promotion_signup");
      if (!recaptchaToken) {
        setErrorMessage("Security verification failed. Please try again.");
        setLoading(false);
        return;
      }
      const formData = new FormData();
      formData.append("email", email);
      formData.append("recaptchaToken", recaptchaToken);
      const response = await newsletterPromotionSignupAction(formData);
      setLoading(false);
      if (response.success) {
        trackNewsletterSignup();
        addGlobalMessage({
          message: response.message,
          messageType: "success"
        });
        onSignupComplete();
      } else {
        setErrorMessage(response.message || "An error occurred. Please try again.");
      }
    };
    $[2] = addGlobalMessage;
    $[3] = email;
    $[4] = executeRecaptcha;
    $[5] = onSignupComplete;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleSubmit = t3;
  let t4;
  if ($[7] !== modalImage) {
    t4 = modalImage && <><Image src={modalImage.mobile} alt="Join our newsletter" width={400} height={300} quality={90} sizes="100vw" className="w-full h-auto block md:hidden" /><Image src={modalImage.desktop} alt="Join our newsletter" width={400} height={600} quality={90} sizes="50vw" className="w-full h-full object-cover hidden md:block" /></>;
    $[7] = modalImage;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div className="w-full md:w-1/2 order-2 md:order-1 md:self-stretch">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FontAwesomeIcon icon={faXmark} className="text-3xl" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onBackgroundClick) {
    t7 = <button onClick={onBackgroundClick} className="absolute top-4 right-4 text-light hover:text-dark transition-colors" aria-label="Close">{t6}</button>;
    $[12] = onBackgroundClick;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex items-center gap-3 mb-3"><FontAwesomeIcon icon={faHiveIconSmallLight} className="text-2xl text-[#F5A623]" /><h2 className="text-2xl md:text-3xl font-extralight">Join Our Newsletter</h2></div>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="text-sm text-light mb-2">Sign up for the hive newsletter and receive a promotion code for <strong className="font-semibold">10% off your next order.</strong></p>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== errorMessage) {
    t10 = errorMessage && <p className="text-sm text-red-600 mb-4">{errorMessage}</p>;
    $[16] = errorMessage;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = e_0 => setEmail(e_0.target.value);
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== email) {
    t12 = <input id="email" type="email" name="email" value={email} onChange={t11} autoComplete="email" placeholder=" " required={true} className="form-input peer" />;
    $[19] = email;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <label htmlFor="email" className="form-input-label peer-placeholder-shown:form-input-label-placeholder-shown">Email</label>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12) {
    t14 = <div className="form-group mb-4">{t12}{t13}</div>;
    $[22] = t12;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== loading) {
    t15 = <SubmitWithPendingButton isPending={loading} pendingText="Signing Up..." className="!py-2.5 !text-sm md:!py-4 md:!text-base">Sign Up</SubmitWithPendingButton>;
    $[24] = loading;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== onRefuse) {
    t16 = <button type="button" onClick={onRefuse} className="text-xs text-light hover:text-dark transition-colors underline">No thanks</button>;
    $[26] = onRefuse;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t15 || $[29] !== t16) {
    t17 = <div className="flex items-center gap-4">{t15}{t16}</div>;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== handleSubmit || $[32] !== t10 || $[33] !== t14 || $[34] !== t17) {
    t18 = <form onSubmit={handleSubmit}>{t10}{t14}{t17}</form>;
    $[31] = handleSubmit;
    $[32] = t10;
    $[33] = t14;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t18 || $[37] !== t7) {
    t19 = <div>{t7}{t8}{t9}{t18}</div>;
    $[36] = t18;
    $[37] = t7;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="mt-6 md:mt-10"><p className="text-3xs text-light leading-relaxed mb-2">{"Offer valid for one-time redemption for purchases on hivemodern.com. Promotions do not include tax, shipping, or sale items. Some products are excluded. Please refer to the shopping cart. A hive customer account is required to use promotion codes. terms & conditions apply."}</p><RecaptchaDisclaimer addClasses="text-3xs leading-relaxed italic" /></div>;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t19) {
    t21 = <div className="w-full md:w-1/2 px-6 md:px-8 py-6 md:py-14 pb-2 md:pb-3 relative flex flex-col justify-between order-1 md:order-2">{t19}{t20}</div>;
    $[40] = t19;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t21 || $[43] !== t5) {
    t22 = <div className="flex flex-col md:flex-row min-h-0">{t5}{t21}</div>;
    $[42] = t21;
    $[43] = t5;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== contentLabel || $[46] !== isOpen || $[47] !== onBackgroundClick || $[48] !== t22) {
    t23 = <Modal overlayClassName="z-[1055] fixed outline-0 top-0 bottom-0 left-0 right-0 bg-modal-overlay" className="fixed top-1/2 left-1/2 right-auto bottom-auto -mr-[50%] -translate-y-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-[400px] md:max-w-[800px] max-h-[calc(100dvh-2rem)] rounded-sm bg-white shadow-2xl outline-none overflow-y-auto" isOpen={isOpen} onAfterOpen={afterOpenModal} onRequestClose={onBackgroundClick} contentLabel={contentLabel} closeTimeoutMS={300} bodyOpenClassName="ReactModal__Body--open" htmlOpenClassName="ReactModal__Html--open">{t22}</Modal>;
    $[45] = contentLabel;
    $[46] = isOpen;
    $[47] = onBackgroundClick;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  return t23;
};
export default NewsletterSignupModal;
function _temp() {
  Modal.setAppElement("#app");
}